import { HttpClient } from "../HttpClient";

export const GetSubscriptionCreditById = async (id) => {
  try {
    const { data } = await HttpClient.get(
      `api/subscriptions/SubscriptionCredit/${id}`
    );
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
